import { Directive, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[ispmOnInit]'
})
export class OnInitDirective implements OnInit {
    @Input('ispmOnInit')
    public onInit: (...args) => void;

    constructor() {
    }

    ngOnInit(): void {
        if (this.onInit) {
            this.onInit();
        }
    }

}
